import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import announcements from "@/frame/messages/mixins/announcements.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
// CAN NOT HAVE CREATE DATABASE createFirebase due to CONFLICT
// import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import btnControl from "@/frame/animation/mixins/btnControl.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import generateLog from "@/document/log/mixins/generateLog.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import statsMods from "@/support/stats/mixins/statsMods.js";

export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [
    generateID,
    announcements,
    dataSources,
    btnControl,
    docRevsModFunctions,
    relationshipsFunctions,
    generateLog,
    statsFunctions,
    relpsFunctions,
    listFunctions,
    displayFunctions,
    dateFunctions,
    statsMods
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getAdmin",
      "getDetail",
      "getDetailRelps",
      "getDetailStats",
      "getDataSource",
      "getSearchResults",
      "getSearchResultsCounter"
    ])
  },
  methods: {
    // UPDATE ITEM
    updateFirebaseDocumentItem(db, did, detail) {
      // console.log("FIREBASE DOC DIRECT UPDATE");
      // console.log(db);
      // console.log(did);
      // console.log(detail);
      // eslint-disable-next-line
      db.doc(did).set(detail)
        .then(
          // eslint-disable-next-line
          this.btnSpinDocumentCommsEdit = false,
          this.showSnackbar("message was changed", "success")
        )
        .catch(error => {
          this.showSnackbar(error.message, "error");
        });
    },
    // UPDATE DOC
    updateFirebaseDocumentDirect(db, did, detail) {
      // console.log("");
      // console.log(" >>> FIREBASE DOC DIRECT UPDATE <<< ");
      // console.log("DID " + did);
      // console.log("TAG " + detail.basic.tag);
      // console.log(db);
      // console.log(detail);
      // eslint-disable-next-line
      db.doc(did).set(detail)
        .then(
          // CHANEG SAVE ICON
          this.$store.dispatch("changeDataSavePendingIndication", false),
          // UPDATE STATS
          this.updateFirebaseDocumentStatsRemote(detail.basic.tag, did),
          // UPDATE RELPS REMOTE
          this.updateFirebaseDocumentRelpsRemote(detail.basic.tag, did),
          // GENERATE LOG
          this.createFirebaseDocumentLogAfterUpdate(detail),
          // GENERATE LOG / UPDATE STATS FOR COMPANY / FACILIT IF REQUIRED
          this.updateCompanyORFacilityStatsLogForDocumentClosed(detail),
          // this.createFirebaseCompanyORFaciilityLogAndUpdateStatsRemoteOpen(
          //   detail
          // ),
          // UPDATE SEARCH RESULTS (IF APPLICABLE)
          this.updateSearchResults(detail),
          // BTN SPIN STOP
          (this.btnSpinChangeDetail = false),
          (this.btnSpinChangeAdmin = false),
          (this.btnSpinDocumentRead = true),
          // CLOSE dialog
          (this.dialog = false)
        )
        .catch(error => {
          console.log(error.message);
          // this.showSnackbar(error.message, "error");
        });
    },
    // UPDATE LOCAL SEARCH LIST
    updateSearchResults(item) {
      // DEFINE
      let tag = item.basic.tag;
      let temp = item;
      temp.basic.list = true; // recently accessed idnicator
      temp.basic.save = true; // save availablke
      // UPDATE EMEDDED LIST which if the list is ACTIVE
      // eslint-disable-next-line
      if (this.getSearchResults !== null && this.getSearchResults !== undefined) {
        if (this.getSearchResults.length > 0) {
          let tagResult = this.getSearchResults[0].basic.tag;
          if (tagResult === tag) {
            // LIST UPDATE
            var tempList = this.getSearchResults;
            var obj = Object.assign({}, temp);
            var parseobj = JSON.parse(JSON.stringify(obj));
            var newList = this.changeItemReturnListCheckDID(parseobj, tempList);
            this.$store.dispatch("changeSearchResults", newList);
            // console.log(newList);
            this.refreshList();
            this.dialog = false;
            // UPDATE LIST
            // console.log("");
            // console.log(">>> SEARCH RESULTS UPDATED <<<");
            // console.log(tag);
            // console.log(temp);
            // console.log(newList);
          }
        }
      }
    },
    refreshList() {
      let store = "changeSearchResultsCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getSearchResultsCounter + 1);
      this.$store.dispatch(store, this.getSearchResultsCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", false);
    },
    // UPDATE STATS REMOTE
    updateFirebaseDocumentStatsRemote(tag, did) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G5");
      let local = this.getDetailStats; // Local STATS
      let remote = null; // Remote STATS
      let stats = null; // Selected STATS

      // HELP
      // console.log("UPDATE FIREBASE STATS REMOTE");
      // console.log(db);
      // console.log(tag);
      // console.log(did);
      // console.log(stats);
      // console.log(this.enableStatsRemote(tag));
      // console.log(this.getDetailStats);

      // CREATE STATS REMOTE for SOME DOCs ONLY
      if (this.enableStatsRemote(tag) && this.getDetailStats !== null) {
        // console.log("ENABLED REMOTE STATS");
        // console.log("DID " + did);
        // console.log("DB :");
        // console.log(db);
        // eslint-disable-next-line
        db.doc(did).get().then((doc) => {
            // GET LATEST STATE (in case if updated by others)
            remote = doc.data();
            stats = this.selectStats(local, remote);
            this.$store.dispatch("changeDetailStats", stats);
            // console.log("STATS COMPARE");
            // console.log(local);
            // console.log(remote);
            // console.log(stats);
            // UPDATE LATEST STATS COUNTERS
            // eslint-disable-next-line
          db.doc(did).set(stats).then(() => {}).catch(() => {
                let msg = "remote stats upload failed";
                this.generateInfoSnackbar("error", msg);
              });
          })
          .catch(error => {
            this.showSnackbar(error.message, "error");
          });
      }
    },
    // UPDATE STATS REMOTE
    updateFirebaseDocumentUserStats(tag, did) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G5");
      let stats = this.getStatsRemote; // Selected STATS
      // HELP
      // console.log("UPDATE FIREBASE USER STATS REMOTE");
      // console.log(db);
      // console.log(tag);
      // console.log(did);
      // console.log(stats);
      // console.log(this.enableStatsRemote(tag));
      // console.log(this.getDetailStats);

      // CREATE STATS REMOTE for SOME DOCs ONLY
      if (this.getStatsRemote !== null) {
        // eslint-disable-next-line
        db.doc(did).set(stats)
          .then(() => {
            // STOP BTN
            let noun = "User Profile was updated to";
            let stat = null;
            let temp = this.getAdmin;
            if (this.getStatsRemote.act === true) {
              stat = "Active";
            } else {
              stat = "Disabled";
            }
            // eslint-disable-next-line
            let verb = " Status: " + stat + " and Licence: " + this.getStatsRemote.rlic + " with an expiry date " + this.dateTypeA(this.getStatsRemote.dexp) + " by System Admin.";
            let log = this.generateLog("U1", noun, verb, temp);
            this.createFirebaseDocumentLog("U1", log);

            // SNACK BAR
            let msg = "User ";
            msg = msg + " " + this.getAdminBasic.title + " was updated to ";
            msg = msg + verb;
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);

            // ROUTER
            this.$router.push("/registerlist");

            // STOP SPIN
            this.btnSpinChangeAdmin = false;

            // CLOSE
            this.dialog = false;
          })
          .catch(() => {
            console.log("TEST 2");
          });
      }
    },
    // UPDATE RELPS REMOTE
    updateFirebaseDocumentRelpsRemote(tag, did) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G6");
      let relps = this.getDetailRelps;
      // HELP
      // console.log("UPDATE FIREBASE RELPS REMOTE");
      // console.log(db);
      // console.log(did);
      // console.log(relps);
      // console.log(this.enableRelpsRemote(tag));
      // console.log(this.getDetailRelps);
      // UPDATE RELPS REMOTE (NO CHECK - APPLY to ALL DOCs)
      if (this.enableRelpsRemote(tag) && this.getDetailRelps !== null) {
        // eslint-disable-next-line
        db.doc(did).set(relps).then(() => {}).catch((error) => {
            let msg = "remote relationships upload failed";
            this.generateInfoSnackbar("error", msg);
          });
      }
    },
    // UPDATE USER ACCESS
    updateFirebaseDocumentUserAccess(udid, detail) {
      // eslint-disable-next-line
      let db = firebase.firestore().collection("person").doc(udid).collection("access")
      let did = detail.basic.did;
      // console.log("");
      // console.log(">>> FIREBASE USER ACCESS UPDATE <<<");
      // console.log("UDID  : " + udid);
      // console.log("DID   : " + did);
      // console.log("TAG   : " + detail.basic.tag);
      // console.log("TAGD  : " + detail.basic.tagd);
      // console.log("TAGS  : " + detail.basic.tags);
      // console.log(db);
      // console.log(detail);
      // eslint-disable-next-line
      db.doc(did).set(detail)
        .then(() => {
          // RESET USER
          this.$store.dispatch("changeUserDID", this.getUser.basic.did);
          // eslint-disable-next-line
          this.$store.dispatch("changeDataSavePendingIndication", false);
          // eslint-disable-next-line
          this.btnSpinChangeDetail = false;
        })
        .then(() => {
          console.log("SNACK BAR");
          // MESSAGE
          let tagd = detail.basic.tagd;
          let tags = detail.basic.tags;
          let msg = null;
          let auth = null;
          // msg = msg + this.displayDocumentIDGTypeA(tag, detail.basic.idg);
          if (tagd === "C1" || tags === "C1") {
            auth = detail.select.cauth;
            msg = "User Access Level " + auth;
            msg = msg + " for Comapny " + detail.char.title;
          } else if (tagd === "F1" || tags === "F1") {
            auth = detail.select.fauth;
            msg = "User Access Level " + auth;
            msg = msg + " for Facility " + detail.char.title;
          } else {
            auth = "Undefined";
          }
          if (detail.basic.lock === true) {
            msg = msg + " is Locked and ";
          }
          if (detail.basic.lock === false) {
            msg = msg + " is Active and ";
          }
          msg = msg + " updated.";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
        })
        .catch(error => {
          this.showSnackbar(error.message, "error");
        });
    },
    // CREATE LOG AFTER UPDATE
    createFirebaseDocumentLogAfterUpdate(doc) {
      // console.log("");
      // console.log("CREATE LOG AFTER DOC UPDATE");
      console.log(doc);
      // GENERATE USER + FACILITY LOG
      // this.createDocumentLogUpdate(doc);
      // GENERATE USER + ASSET LOG
      // console.log(">>> GENERATE DOCUMENT LOG <<<");
      // console.log(doc);
    },
    updateCompanyORFacilityStatsLogForDocumentClosed(doc) {
      // console.log("");
      // console.log("Update Company OR Facility Stats Log For Document Closed");
      // console.log("DOC : ");
      // console.log("TAG : " + doc.basic.tag);
      // console.log("TITLE : " + doc.basic.title);
      let tag = doc.basic.tag;
      let status = null;

      // CHECK STATUS
      if (doc.trans !== undefined && doc.trans !== null) {
        let flow = doc.trans.flow;
        status = flow[flow.length - 1].title;
      }

      if (status === "Cancelled" || status === "Closed") {
        // SNACKABR
        let msg = "";
        msg = msg + this.defineDocumentFromTag(tag).title;
        msg = msg + " ";
        msg = msg + this.displayDocumentIDGTypeA(tag, doc.basic.idg) + " ";
        msg = msg + doc.basic.title + " ";
        msg = msg + "was " + status + ".";
        this.generateInfoSnackbar(this.ui.colorBlue1, msg);
        // COMPANY STATS + lOG UPDATE
        if (
          tag === "B3" ||
          tag === "B4" ||
          tag === "B6" ||
          tag === "E2" ||
          tag === "Q1" ||
          tag === "S6"
        ) {
          let flow = doc.trans.flow;
          status = flow[flow.length - 1].title;
          let message = "was " + status + ".";
          this.updateCompanyStatsCloseDoc(doc);
          this.generateUserLog(doc, message);
          this.generateCompanyLog(doc, message);
        }
        // FACILITY STATS + lOG UPDATE
        // eslint-disable-next-line
        if (
          tag === "O1" ||
          tag === "W1" ||
          tag === "W2"
        ) {
          let flow = doc.trans.flow;
          status = flow[flow.length - 1].title;
          let message = "was " + status + ".";
          this.updateFacilityStatsCloseDoc(doc);
          this.generateUserLog(doc, message);
          this.generateFacilityLog(doc, message);
        }
      }
    },
    createFirebaseCompanyORFaciilityLogAndUpdateStatsRemoteOpen(doc) {
      // console.log("");
      // console.log("CLOSED ITEM");
      // console.log(doc.basic.tag);
      let tag = doc.basic.tag;
      if (tag === "C1" || tag == "F1") {
        let flow = doc.trans.flow;
        let status = flow[flow.length - 1].title;
        if (status !== "Closed") {
          // COMPANY CLOSE ITEM
          if (
            tag === "B3" ||
            tag === "B4" ||
            tag === "B6" ||
            tag === "E2" ||
            tag === "Q1" ||
            tag === "S6"
          ) {
            this.generateUserLog(doc, "was closed.");
            // this.generateUserLogClosed(doc);
            // this.generateCompanyLogClosed(doc);
            // console.log("DECREMENT ONE");
            this.decrementCompanyStatsOpenUpdateCompanyLog(doc);
          }
          // FACILITY CLOSE ITEM
          // eslint-disable-next-line
          if (tag === "O1" || tag === "W1" || tag === "W2") {
            this.generateUserLog(doc, "was closed.");
            this.decrementFacilityStatsOpenUpdateCompanyLog(doc);
          }
        }
      }
    }
  }
};
